import { synapse } from '@ublique/platform'
import { BASE_URL } from 'config'
import { memoize } from 'lodash'

export const _fetch = async (endPoint, method = 'GET', body = null) => {
  const url = `${BASE_URL}${endPoint}`
  try {
    const res = await synapse.fetch(
      url,
      {
        method
      },
      body
    )
    if (res.status !== 200) {
      console.error(`Couldn't get data`)
      return null
    }

    return res.body ?? {}
  } catch (err) {
    console.warn(err)
    return null
  }
}

export async function executeFetch(url, body, type) {
  return _fetch(url, type, body)
}

export const fetchStoresList = memoize(async () => {
  const url = `/output/store-collaboration/filters/stores`

  return await executeFetch(url)
})

export const fetchRoomsList = async (storeId) => {
  const url = `/output/store-collaboration/filters/store/${storeId}/rooms`

  return await executeFetch(url)
}
